import { render, staticRenderFns } from "./MSOChartOfAccounts.vue?vue&type=template&id=8cda053e&"
import script from "./MSOChartOfAccounts.vue?vue&type=script&lang=js&"
export * from "./MSOChartOfAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports